module.exports = __webpack_public_path__ + "static/glaces-24aab155338e16b9d1caa7da1f3e0bf2.jpg";